<template>
  <div class="app" v-if="orderInfo">
    <headerNav title="支付" />
    <div class="price-box" v-if="abp.userInfo.memberLevelModel.isRetail">
      <span>{{ orderInfo.isIntegralTrade ? "支付邮费" : "支付金额" }}</span>
      <span class="price">{{
        orderInfo.isIntegralTrade ? orderInfo.postFee : orderInfo.payment
      }}</span>
    </div>
    <div v-else>
      <div v-if="orderInfo.bigMoney" class="zprice-box">
        <span>大货金额</span>
        <span>{{ orderInfo.bigMoney }}</span>
      </div>
      <div v-if="orderInfo.assistMoney" class="zprice-box">
        <span>物料金额</span>
        <span>{{ orderInfo.assistMoney }}</span>
      </div>
      <div v-if="orderInfo.postFee" class="zprice-box">
        <span>运费<span v-if="orderInfo.isEnabledSmallPay">(物料款支付)</span></span>
        <span>{{ orderInfo.postFee }}</span>
      </div>
      <div v-if="orderInfo.bigMoney" class="zprice-box">
        <span>当前大货余额</span>
        <span>{{ userInfo.largeLoans }}</span>
      </div>
      <div v-if="orderInfo.assistMoney||(orderInfo.isEnabledSmallPay&&orderInfo.postFee)" class="zprice-box">
        <span>当前物料余额</span>
        <span>{{ userInfo.accessoriesLoans }}</span>
      </div>
    </div>

    <div class="pay-type-list">
      <van-radio-group v-model="payType">
        <div class="type-item" v-if="abp.userInfo.memberLevelModel.isRetail">
          <van-icon
            class="main-list-icon-right"
            :size="26"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="weixinzhifu"
          />
          <!-- <text class="icon yticon icon-erjiye-yucunkuan"></text> -->
          <div class="con">
            <span class="tit">微信支付</span>
            <span>推荐使用微信支付</span>
          </div>
          <van-radio name="1" :checked-color="$abctheme.basecolor"></van-radio>
        </div>
        <div class="type-item" v-if="!abp.userInfo.memberLevelModel.isRetail">
          <van-icon
            class="main-list-icon-right"
            :size="26"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="jindutiaoqiandai"
          />
          <!-- <text class="icon yticon icon-erjiye-yucunkuan"></text> -->
          <div class="con">
            <span class="tit">预存款支付</span>
            <!-- <span>可用余额 ¥{{curmoney}}</span> -->
          </div>
          <van-radio name="3" :checked-color="$abctheme.basecolor"></van-radio>
          <!-- <label class="radio">

<radio value="" color="#fa436a" :checked='payType == 3' />

</label> -->
        </div>
      </van-radio-group>
    </div>
    <van-popup v-model="showpay">
      <van-loading size="24px" />
    </van-popup>
    <van-button class="mix-btn" :color="$abctheme.basecolor" @click="confirm"  :disabled="disabled"
      >确认支付</van-button
    >
    <van-popup
      v-model="show_key"
      closeable
      position="bottom"
      :style="{ height: '348px' }"
    >
      <van-password-input
        :value="paydto.paypwd"
        :error-info="errorInfo"
        :focused="show_key"
        @focus="show_key = true"
        :gutter="15"
        :style="{ 'margin-top': '38px' }"
      />
      <van-number-keyboard
        :show="show_key"
        @input="onInput"
        @delete="onDelete"
        @blur="show_key = false"
      />
    </van-popup>
  </div>
</template>

<script>
import request from "../../config/ajax";
import AppConsts from "../../config/appconst";
export default {
  data() {
    return {
      payType: "3",
      getparams: {
        tid: "",
        maxResultCount: 1,
        skipCount: 0,
      },
      orderInfo: undefined,
      paydto: {
        tid: "",
        paypwd: "",
        guid: "",
      },
      payH5dto: {
        tid: "",
        openid: "",
      },
      showpay: false,
      show_key: false,
      userInfo: {},
      errorInfo: "",
      curmoney: 0,
      disabled: false,
    };
  },
  created() {
    var options = this.$route.query;
    //判断是不是零售端
    //console.log(this.$route);
    this.getparams.tid = options.tid;
    this.payH5dto.tid = options.tid;
    this.abp.userInfo.openid = this.abp.userInfo.openid || localStorage.getItem("openid");
    if (process.env.NODE_ENV == "production" &&!this.abp.userInfo.openid) {
      let payorderwx = localStorage.getItem("payorderwx");
      if (payorderwx) {
        var code = this.getQueryVariable("code");
        console.log("获取code", code);
        if (code) {
          this.ajax
            .post("/api/services/app/PhoneAccount/WxOAuth?code=" + code)
            .then((x) => {
              localStorage.setItem("payorderwx", "");
              console.log("获取opneid", x.result);
              this.abp.userInfo.openid = x.result;
              localStorage.setItem("openid", this.abp.userInfo.openid);
              this.payH5dto.openid = x.result;
              this.paydto.openid = x.result;
            });
        } else {
          if (process.env.NODE_ENV == "production") {
            localStorage.setItem("payorderwx", "1");
            location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
              AppConsts.wxappid +
              "&redirect_uri=http%3a%2f%2f" +
              location.host +
              "%2f%23%2fpay%3ftid%3d" +
              this.getparams.tid +
              "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";

            return;
          }
        }
      }else{
         if (process.env.NODE_ENV == "production") {
            localStorage.setItem("payorderwx", "1");
            location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
              AppConsts.wxappid +
              "&redirect_uri=http%3a%2f%2f" +
              location.host +
              "%2f%23%2fpay%3ftid%3d" +
              this.getparams.tid +
              "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";

            return;
          }
      }
    } else {
      this.payH5dto.openid = this.abp.userInfo.openid;
      this.paydto.openid = this.abp.userInfo.openid;
    }

    if (this.abp.userInfo.memberLevelModel.isRetail) {
      this.payType = "1";
    } else {
      this.payType = "3";
    }

    this.getTrade();
    this.getUserInfo();
  },
  methods: {
    onInput(key) {
      this.paydto.paypwd = (this.paydto.paypwd + key).slice(0, 6);
      if (this.paydto.paypwd.length === 6) {
        this.getPassword(this.paydto.paypwd);
      } else {
        this.errorInfo = "";
      }
    },
    onDelete() {
      this.paydto.paypwd = this.paydto.paypwd.slice(0, this.paydto.paypwd.length - 1);
    },
    //选择支付方式
    changePayType(type) {
      this.payType = type;
    },
    getTrade() {
      request
        .post("/api/services/app/PhoneTrade/QueryPayOrderModel", this.getparams)
        .then((x) => {
          this.orderInfo = x.result;
          if (this.orderInfo.tranferOrderState != 0) {
            localStorage.setItem("paysuccessnavurl", "/cloundorderlist?state=2");
          } else {
            localStorage.setItem("paysuccessnavurl", "/user/order");
          }
          // if(this.orderInfo.bigMoney>0)
          // {

          // }

          // if(this.orderInfo.assistMoney>0)
          // {
          // 	this.curmoney=this.userInfo.accessoriesLoans;
          // }
        });
    },
    //获取订单信息并可以发起支付
    //确认支付
    confirm() {
      this.disabled = true;
      switch (this.payType) {
        case "1":
          //微信支付
          this.showpay = true;
          this.ajax
            .post("/api/services/app/PhoneTrade/PayH5SignInfo", this.payH5dto)
            .then((x) => {
              var wxpaydata = x.result;
              if (!wxpaydata.needWxPay) {
                //免支付  直接跳到支付成功
                this.$router.push({
                  path: "paysuccess",
                });
                return;
              }
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    this.onBridgeReady,
                    false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                  document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
                }
                location.href = wxpaydata.mweb_url;
              } else {
                this.onBridgeReady(wxpaydata);
              }
            })
            .finally((x) => {
              this.showpay = false;
              this.disabled = false;
            });
          //this.$toast("暂未实现");
          break;
        case "2":
          this.$toast("暂未实现");
          break;
        case "3":
          if (
            this.orderInfo.bigMoney > 0 &&
            this.userInfo.largeLoans < this.orderInfo.bigMoney
          ) {
            this.$toast("大货余额不足");
            this.disabled = false;
            return;
          }
          var orderassistMoney=this.orderInfo.assistMoney;
          if(this.orderInfo.isEnabledSmallPay&&this.orderInfo.postFee)
          {
              orderassistMoney+=this.orderInfo.postFee;
          }
          if (
            this.orderInfo.assistMoney > 0 &&
            this.userInfo.accessoriesLoans < orderassistMoney
          ) {
            this.$toast("物料余额不足");
            this.disabled = false;
            return;
          }
          // if (this.userInfo.balance < this.orderInfo.payment) {
          // 	this.$toast("余额不足");
          // 	return;
          // }
          request.post("/api/services/app/PhoneUser/IsSetPayPwd", {}).then((x) => {
            if (!x.result) {
              this.$dialog
                .alert({
                  title: "提示",
                  message: "检测到您未设置支付密码,点击确定去设置支付密码",
                })
                .then(() => {
                  //跳转设置密码
                  this.$router.push({
                    name: "setpwd",
                  });
                })
                .finally(() => {
                  this.disabled = false;
                });
            } else {
              this.showFun();
              this.disabled = false;
            }
            //this.$api.msg("支付成功");
            // uni.redirectTo({
            // 	url: '/pages/money/paySuccess'
            // })
          });

          break;
        default:
          break;
      }
    },
    onBridgeReady(params) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: params.appid, //公众号名称，由商户传入
          timeStamp: params.timeStamp + "", //时间戳，自1970年以来的秒数
          nonceStr: params.nonceStr, //随机串
          package: params.package,
          signType: params.signType, //微信签名方式：
          paySign: params.sign, //微信签名
        },
        (res) => {
          //alert(JSON.stringify(res));
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            localStorage.setItem('paysuccesstid',this.payH5dto.tid);
            this.$toast("支付成功");
            this.$router.push({
              path: "paysuccess",
            });
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      );
    },
    showFun() {
      this.paydto.paypwd = "";
      this.show_key = true;
    },
    hideFun() {
      this.show_key = false;
    },
    getPassword(n) {
      //console.log(this.getparams);
      this.paydto.paypwd = n;
      //console.log(n);
      this.paydto.tid = this.getparams.tid;

      request.post("/api/services/app/PhoneTrade/BalancePay", this.paydto).then((x) => {
        this.show_key = false;
        var wxpaydata = x.result;
        if (!wxpaydata.needWxPay) {
          localStorage.setItem('paysuccesstid',this.paydto.tid);
          this.$toast("支付成功");
          this.$router.push({
            path: "paysuccess",
          });
        } else {
          this.onBridgeReady(wxpaydata);
        }
      });
    },
    getUserInfo() {
      request.post("/api/services/app/PhoneUser/QueryUserInfo").then((x) => {
        this.userInfo = x.result;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.price-box {
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #909399;
}

.price {
  font-size: 25px;
  color: #303133;
  margin-top: 6px;

  &:before {
    content: "￥";
    font-size: 20px;
  }
}

.price:before {
  content: "￥";
  font-size: 20px;
}

.pay-type-list {
  margin-top: 10px;
  padding-left: 30px;
}

.type-item {
  height: 60px;
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 30px;
  font-size: 15px;
  position: relative;
  border-bottom: 1px solid #e2e2e2;
}

.type-item:last-child {
  border-bottom: 0px;
}

.icon {
  width: 25px;
  font-size: 13px;
}

.icon-erjiye-yucunkuan {
  color: #fe8e2e;
}

.icon-weixinzhifu {
  color: #36cb59;
}

.icon-alipay {
  color: #01aaef;
}

.tit {
  font-size: 16px;
  color: #303133;
  margin-bottom: 2px;
}

.con {
  padding-left: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: #909399;
}

.mix-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 315px;
  height: 40px;
  margin: 40px auto 15px;
  font-size: 16px;
  color: #fff;
  background-color: #ffe200;
  border-radius: upx;
  box-shadow: 1px 2px 5px rgba(219, 63, 96, 0.4);
}

.zprice-box {
  text-align: left;
  padding: 5px 5px 5px 30px;
  font-size: 14px;
}
</style>
